"use client";

import {
  BadgeCheck,
  Bell,
  ChevronsUpDown,
  CreditCard,
  LogOut,
  Sparkles,
} from "lucide-react";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/shadcn/avatar.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/shadcn/dropdown-menu.tsx";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/shadcn/sidebar.tsx";
import React, { useContext } from "react";
import { UserContext } from "@/store/context/UserContext.tsx";
import { useTranslation } from "react-i18next";

import Api from "@/store/api.ts";
import { constants } from "@/constants";
import { useNavigate } from "react-router-dom";
import {Icon} from "@/components/Icon.tsx";
import { isPlatform, platformWizyChat } from "@/domains.ts";

export function NavUser() {
  const { isMobile } = useSidebar();
  const { userSettings, setUserSettings } = useContext(UserContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navigateToProfile = (e: CustomEvent) => {
    e.stopPropagation();
    navigate(`/profile`);
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div>
                <Icon icon="fluent:person-circle-24-regular" className="opacity-70" width={24} />
              </div>
              {/*<Avatar className="h-8 w-8 rounded-lg">*/}
                {/*<img*/}
                {/*  src={UserAvatar}*/}
                {/*  alt=""*/}
                {/*  className="block w-full h-full object-cover rounded-full"*/}
                {/*/>*/}
                {/*<AvatarImage src={"user.avatar"} alt={user.name} />*/}
                {/*<AvatarFallback className="rounded-lg">CN</AvatarFallback>*/}
              {/*</Avatar>*/}
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold w-[70px] sm:w-full">
                  {userSettings.email}
                </span>
                {/*<span className="truncate text-xs">{user.email}</span>*/}
              </div>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "bottom"}
            align="end"
            sideOffset={4}
          >
            {/*<DropdownMenuLabel className="p-0 font-normal">*/}
            {/*  <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">*/}
            {/*    <Avatar className="h-8 w-8 rounded-lg">*/}
            {/*      <AvatarImage src={user.avatar} alt={user.name} />*/}
            {/*      <AvatarFallback className="rounded-lg">CN</AvatarFallback>*/}
            {/*    </Avatar>*/}
            {/*    <div className="grid flex-1 text-left text-sm leading-tight">*/}
            {/*      <span className="truncate font-semibold">{user.name}</span>*/}
            {/*      <span className="truncate text-xs">{user.email}</span>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</DropdownMenuLabel>*/}
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={navigateToProfile}>
                <BadgeCheck />
                {t("account")}
              </DropdownMenuItem>
              {isPlatform(platformWizyChat) && (
                <a href="https://wizychat.canny.io/changelog" target="_blank">
                  <DropdownMenuItem onClick={navigateToProfile}>
                    <Icon icon="fluent:megaphone-loud-20-regular" height="20" />
                    Changelog
                  </DropdownMenuItem>
                </a>
              )}
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                Api.dispatchSignOutEvent(constants.url.MAIN_SITE_URL);
              }}
            >
              <LogOut />
              {t("log_out")}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
